import { siteApi } from "@api/index";
import { useWSPlaySpinUpdated } from "@hooks/useAppWS";
import { PlaySpinTxStatus, WalletTxMethod } from "kz-ui-sdk";
import { useMemo } from "react";
import useUserMode from "./useUserMode";

const DEFAULT_TARGET_AMT = 1000;
const DEFAULT_CURRENT_AMT = 1000;

export const usePlaySpinStatus = (options?: { disableWsRefetch?: boolean }) => {
  const { isGuest } = useUserMode();
  // Play and spin
  const {
    data: rewardStatus,
    isLoading: isFetchingRewardStatus,
    refetch: refetchRewardStatus,
  } = siteApi.useGetRewardsStatusQuery(undefined, {
    skip: isGuest,
  });

  useWSPlaySpinUpdated({
    cb: () => {
      if (options?.disableWsRefetch) return;
      refetchRewardStatus();
    },
  });

  const {
    isPlayAndSpinAvailable,
    isPlayAndSpinClaimable,
    playAndSpinLockedInstructions,
    isPlayAndSpinLocked,
    playAndSpinBonusDetails,
    rewardTypes,
  } = useMemo(() => {
    const playAndSpinStatus = rewardStatus?.[WalletTxMethod.PlaySpin];
    const bonusAmt = playAndSpinStatus?.lastPlaySpinTx?.bonusAmt;
    const currentAmt = playAndSpinStatus?.lastPlaySpinTx?.currentAmt;
    const targetAmt = playAndSpinStatus?.lastPlaySpinTx?.targetAmt;
    const startedAt = playAndSpinStatus?.lastPlaySpinTx?.startedAt;
    const issuedAt = playAndSpinStatus?.lastPlaySpinTx?.issuedAt;
    const status = playAndSpinStatus?.lastPlaySpinTx?.status;
    const isPlayAndSpinLocked = !!playAndSpinStatus?.enabled && !!playAndSpinStatus?.lockedInstructions;

    return {
      isPlayAndSpinAvailable:
        !!playAndSpinStatus?.enabled &&
        (!!playAndSpinStatus?.lockedInstructions || !!playAndSpinStatus?.lastPlaySpinTx),
      isPlayAndSpinClaimable: !!playAndSpinStatus?.enabled && status === PlaySpinTxStatus.Issued,
      isPlayAndSpinLocked,
      playAndSpinLockedInstructions: playAndSpinStatus?.lockedInstructions,
      playAndSpinBonusDetails: {
        bonusAmt,
        targetAmt: targetAmt ?? DEFAULT_TARGET_AMT,
        startedAt,
        issuedAt,
        status,
        currentAmt: currentAmt ?? DEFAULT_CURRENT_AMT,
      },
      rewardTypes: playAndSpinStatus?.rewardTypes,
    };
  }, [rewardStatus]);

  return {
    isPlayAndSpinAvailable,
    isPlayAndSpinClaimable,
    playAndSpinLockedInstructions,
    isPlayAndSpinLocked,
    playAndSpinBonusDetails,
    isFetchingRewardStatus,
    rewardTypes,
    refetchRewardStatus,
  };
};
